import { Component } from '@angular/core';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';

import { PeopleflowFooterComponent } from 'src/app/peopleflow-footer/peopleflow-footer.component';

@Component({
  selector: 'app-blog-custom',
  imports: [HeaderLatestComponent, PeopleflowFooterComponent],
  templateUrl: './blog-custom.html',
  styleUrl: './blog-custom.scss',
})
export class BlogCustom {

}
